import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import {
  Component,
  Directive,
  Output,
  EventEmitter,
  Input,
  SimpleChange,
  HostListener,
  HostBinding
} from '@angular/core';

@Directive({
  selector: 'img'
})
export class DefaultImageDirective {
  @HostBinding('src')
  @Input()
  src: string;

  @Input('type') type: string;

  @HostListener('error', ['$event'])
  onError(e: any) {
    if (this.type === 'user-img') {
      this.src = './default/user-img.png';
    } else if (this.type === 'company-img') {
      this.src = '/default/company-img.png';
    } else if (this.type === 'default-img') {
      this.src = '/default/no-image.png';
    }
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/directives/control/default-image.ts